import { push } from 'react-router-redux';
import { call, put, select } from 'redux-saga/effects';

import * as Actions from '../../../actions';
import { getInDomain, noopWithErrorLog } from '../../../domains/externalUtils';
import { putAndWait } from '../../../sagas/TaskManager';
import Logger from '../../../tools/Logger';
import * as Utils from '../../../utils';

const log = Logger.child({
  component: 'mediator/login',
});

export function* handlePostAuth() {
  const shouldNavigateToCommunity = yield select(Utils.Application.shouldNavigateToCommunity);
  if (shouldNavigateToCommunity) {
    yield put(Actions.Login.loginFlowComplete());
    yield put(push(Utils.Route.getCommunityRedirectPath()));
    return;
  }

  const ampSSO = yield select(Utils.QueryParams.getAmpSSO);
  if (ampSSO) {
    const ampUrl = yield select(Utils.TunerVars.getAmpUrl, ampSSO);
    if (ampUrl) {
      yield put(Actions.Login.loginFlowComplete());
      yield put(Actions.Application.externalRedirect(ampUrl));
      return;
    }
  }

  // check to see if the next path is the same as this one as the hash should be dropped if the new location isn't the same as the current
  let nextPath = yield select(Utils.Route.getNextPath, false);
  if (nextPath === window.location.pathname && window.location.hash) {
    nextPath += window.location.hash;
  }

  // if playback enabled and listener is logged in (anon first time or registered listener) start playback
  const isLoggedIn = yield select(Utils.Listener.isLoggedIn);
  const isPlaybackEnabled = yield select(Utils.Capabilities.isPlaybackEnabled);
  const isInAntiAdBlockHammerMode = yield select(
    getInDomain('application.utils.isAntiAdBlockerHammerModeDetected'),
  );
  if (isLoggedIn && isPlaybackEnabled && !isInAntiAdBlockHammerMode) {
    yield put(getInDomain('playback.actions.setAutoStartEnabled', noopWithErrorLog)(true));
  }

  // clear post auth redirect
  yield put(Actions.Login.loginFlowComplete());

  // redirect to post auth path
  yield put(push(nextPath));
}

export function* login({ payload }) {
  try {
    yield call(putAndWait, Actions.Login.authenticateListener(payload));
    yield call(handlePostAuth);
  } catch (err) {
    log.error(err, 'login(): unable to login user');
    return;
  }
}
